import styled from 'styled-components';

export const TopContentContainer = styled.div`
	width: 100%;
	padding: 20px;
	background-image: linear-gradient(
		135deg,
		#dddddd 25%,
		transparent 25%,
		transparent 50%,
		#dddddd 50%,
		#dddddd 75%,
		transparent 75%,
		transparent 100%
	);
	background-size: 5.5px 5.5px;
	@media screen and (max-width: 650px) {
		padding: 5px 0;
	}
`;

export const SelectableWrapper = styled.div<{ selected: boolean }>`
	width: calc(33% - 16px);
	display: flex;
	background-color: ${({ selected }) => (selected ? '#04a4ec' : '#fff')};
	margin: 8px;
	border-radius: 7px;
	border: 2px solid ${({ selected }) => (selected ? '#0083c8' : '#ccc')};
	color: ${({ selected }) => (selected ? '#fff' : '#000')};
	justify-content: center;
	align-items: center;
	cursor: pointer;
	user-select: none;
	height: 65px;
	transition: border 75ms linear, background-color 75ms linear,
		color 75ms linear;
	${({ selected }) =>
		!selected &&
		`
        &:hover {
            border: 2px solid #333;
        }
    `}
	@media screen and (max-width: 650px) {
		&.no-select {
			width: calc(100% - 16px);
		}
	}
`;

export const SelectablesContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-flow: row wrap;
	.w-33 {
		width: 33%;
	}
	@media screen and (max-width: 650px) {
		.w-33 {
			width: calc(66% - 16px);
		}
	}
`;

export const OCBottomFont = styled.p`
	width: 78%;
	margin: auto;
	text-align: center;
	color: #676767;
	font-size: 14px;
	span {
		color: #000;
		font-weight: 600;
	}
`;

export const OCBottomSelectables = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
`;

export const ConsentRowWrapper = styled.div<{ checked: boolean }>`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 2px 10px;
	border-bottom: 1px solid #ccc;
	font-size: 12px;
	transition: background-color 75ms linear, color 75ms linear;
	&:first-child {
		border-top: 1px solid #ccc;
	}
	&:hover {
		background-color: #f5f5f5;
		p {
			color: #000;
		}
	}
	p {
		user-select: none;
		cursor: pointer;
		color: ${({ checked }) => (checked ? '#000' : '#6d6d6d')};
		font-size: 14px;
	}
`;

export const BottomContentContainer = styled.div`
	margin: 0 5px;
`;

export const NNWBottomHeadingFont = styled.p`
	text-align: center;
	font-weight: 600;
	margin-top: 5px;
	font-size: 16px;
`;

export const TileContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	flex-flow: column nowrap;
	p {
		margin: 0;
	}
	p:nth-child(1) {
		font-size: 17px;
	}
	p:nth-child(3) {
		font-size: 14px;
	}
	div {
		width: 80%;
		height: 1px;
		background-color: #eeeeee;
		margin: 2px 0;
	}
`;

export const NNWContentContainer = styled.div`
	background-image: linear-gradient(
		135deg,
		#e7e7e7 25%,
		#f3f3f3 25%,
		#f3f3f3 50%,
		#e7e7e7 50%,
		#e7e7e7 75%,
		#f3f3f3 75%,
		#f3f3f3 100%
	);
	background-size: 5.5px 5.5px;
	width: 100%;
	padding: 12px;
`;

export const NNWContentHeadingContainer = styled.div`
	width: 70%;
	margin: 5px auto;
	border: 2px solid #0063a4;
	position: relative;
	background-color: #fff;
	border-radius: 150px;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: center;
	user-select: none;
	p {
		color: #0063a4;
		margin: 0;
	}
	@media screen and (max-width: 650px) {
		width: 100%;
	}
`;

export const NNWContentHeadingIcon = styled.div`
	position: absolute;
	right: 2px;
	top: 50%;
	transform: translateY(-50%);
	border-radius: 50%;
	width: 36px;
	height: 36px;
	background-color: #0063a4;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		fill: #fff;
	}
`;

export const NNWContentTableRow = styled.div`
	display: flex;
	width: 100%;
	&:first-child > div:not(:first-child) {
		border: 2px solid #ccc;
		border-bottom: unset;
		border-radius: 5px 5px 0 0;
		padding-bottom: 6px;
		padding-top: 6px;
		font-weight: 600;
		&[data-column-active='true'] {
			border: 2px solid #05a4ec;
			border-bottom: unset;
			color: #0063a4;
		}
	}
	&:last-child > div:not(:first-child) {
		border-bottom: 2px solid #ccc;
		border-radius: 0 0 5px 5px;
		&::after {
			all: unset;
		}
		&[data-column-active='true'] {
			border-bottom: 2px solid #05a4ec;
		}
	}
	&:not(:first-child):hover > div:first-child {
		background-color: #fcfcb8;
	}
	&:not(:first-child):hover > div:not(:first-child) {
		background-color: #fcfcb8;
	}
`;

export const NNWContentTableBlankCell = styled.div`
	flex: 2;
	padding: 12px 4px;
	@media screen and (max-width: 650px) {
		width: 150px;
		min-width: 150px;
		flex: unset;
		&.bottom {
			display: none;
		}
	}
`;

export const NNWContentTableNameCell = styled.div`
	flex: 2;
	color: #6f6f6f;
	font-size: 14px;
	line-height: 1.2;
	padding: 12px 4px;
	position: relative;
	transition: background-color 75ms linear;
	display: flex;
	justify-items: center;
	flex-flow: column nowrap;
	&::after {
		content: '';
		position: absolute;
		width: 98%;
		height: 1px;
		background-color: #c7c7c7;
		bottom: 0;
		left: 0;
	}
	@media screen and (max-width: 650px) {
		width: 150px;
		min-width: 150px;
		flex: unset;
	}
`;

export const NNWContentTableCell = styled.div`
	flex: 1;
	background-color: #fff;
	margin: 0 3px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-left: 2px solid #ccc;
	border-right: 2px solid#ccc;
	position: relative;
	font-size: 14px;
	transition: background-color 75ms linear;
	&[data-column-active='true'] {
		border-left: 2px solid #05a4ec;
		border-right: 2px solid #05a4ec;
	}
	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 85%;
		height: 1px;
		background-color: #c7c7c7;
	}
	@media screen and (max-width: 650px) {
		width: 100px;
		min-width: 100px;
		flex: unset;
	}
`;

export const ExpandAssistanceButton = styled.div<{ expanded: boolean }>`
	cursor: pointer;
	display: flex;
	position: relative;
	border-radius: 40px;
	background-color: #fff;
	color: #4d4d4d;
	width: 70px;
	height: 22px;
	border: 2px solid ${({ expanded }) => (expanded ? '#0088C7' : '#4d4d4d')};
	align-items: center;
	justify-content: center;
	padding-right: 15px;
	font-size: 11px;
	user-select: none;
	div {
		background-color: ${({ expanded }) =>
			expanded ? '#0088C7' : '#4d4d4d'};
		position: absolute;
		right: 0;
		top: 0;
		height: 100%;
		width: 20px;
		border-radius: 0 5px 5px 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 2px;
	}
	svg {
		fill: #fff;
		width: 13px;
		height: 13px;
		transition: rotate 150ms linear;
		${({ expanded }) =>
			expanded &&
			`
			rotate: 180deg;
		`}
	}
`;

export const nnwContentTableSelectableStyle: React.CSSProperties = {
	width: '100%',
	height: '50px',
	fontSize: '16px',
};

export const NNWTableNoSelectContainer = styled.div`
	flex: 4;
	margin-top: 10px;
	margin-left: -12px;
	margin-right: 3px;
	@media screen and (max-width: 650px) {
		margin-left: 0;
		margin-right: 0;
	}
`;
